import React from 'react';

import {
  ReactComponent as CatIcon,
} from '../../../../assets/petDemos/cat.svg';
import {
  ReactComponent as DogIcon,
} from '../../../../assets/petDemos/dog.svg';
import checkIcon from '../../../../assets/petDemos/check-blue.svg';
import { PET_DEMOS_SPECIES } from '../../../../constants';

import styles from './css/DropdownItem.module.css';

const SPECIE_ICON_COMPONENT = {
  [PET_DEMOS_SPECIES.cat]: CatIcon,
  [PET_DEMOS_SPECIES.dog]: DogIcon,
};

const CustomOption = ({ data, innerProps, isSelected }) => {
  const { pet } = data;
  const { Name = '', Specie = PET_DEMOS_SPECIES.dog } = pet || {};

  const IconComponent = SPECIE_ICON_COMPONENT[Specie]
    || SPECIE_ICON_COMPONENT[PET_DEMOS_SPECIES.dog];

  return (
    <li
      {...innerProps}
      aria-selected={isSelected}
      className={`${styles.dropdownItem} ${
        isSelected ? styles.selected : ''
      }`}
      id={`dropdownItem${pet.Id}`}
      role="option"
    >
      <div className={styles.itemContent}>
        <IconComponent
          aria-label={Specie}
          className={styles.petIcon}
        />

        <span className={styles.petName}>{Name}</span>
      </div>

      {isSelected && (
        <img
          alt=""
          className={styles.checkIcon}
          src={checkIcon}
        />
      )}
    </li>
  );
};

export { CustomOption };
